var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCrown2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EBED0EA9-19EC-4817-870A-D2CE57C67DD7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-108.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown",
    transform: "translate(108.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0003147,15.2895079 C22.0003147,18.0495079 19.7603147,20.2895088 17.0003147,20.2895088 L7.00031459,20.2895088 C6.54031458,20.2895088 6.10031468,20.2295085 5.67031467,20.1095085 C5.05031466,19.9395085 4.8503145,19.1495084 5.31031451,18.6895084 L15.9403143,8.05950832 C16.1603143,7.83950832 16.4903139,7.78950781 16.8003139,7.84950781 C17.1203139,7.90950781 17.470314,7.81950782 17.720314,7.57950783 L20.2903156,4.99950796 C21.2303156,4.05950797 22.0003147,4.36950791 22.0003147,5.70950794 L22.0003147,15.2895079 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17000008,17.8295307 C3.69000009,18.3095307 2.88999993,18.189531 2.56999993,17.5895309 C2.19999993,16.9095309 2,16.1195307 2,15.2895308 L2,5.70953131 C2,4.36953127 2.77000004,4.05953127 3.71000004,4.99953127 L6.28999996,7.58953142 C6.67999995,7.96953142 7.32000005,7.96953142 7.71000004,7.58953142 L11.29,3.99953124 C11.6799999,3.60953125 12.3200001,3.60953125 12.71,3.99953124 L14.6499996,5.93953133 C15.0299996,6.32953131 15.0300003,6.96953142 14.6400003,7.3595314 L4.17000008,17.8295307 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCrown2);
export default __webpack_public_path__ + "static/media/vuesax-bold-crown_2.44955081b5aec9434aebe5656083f845.svg";
export { ForwardRef as ReactComponent };